export const GET_ASSETS = 'estatePlan/GET_ASSETS';
export const GET_ASSETS_BY_CATEGORY = 'estatePlan/GET_ASSETS_BY_CATEGORY';
export const ADD_ASSET = 'estatePlan/ADD_ASSET';
export const EDIT_ASSET = 'estatePlan/EDIT_ASSET';
export const DELETE_ASSET = 'estatePlan/DELETE_ASSET';
export const DELETE_DOCUMENT = 'estatePlan/DELETE_DOCUMENT';
export const GET_SHARED_ASSETS = 'immediateAccess/GET_SHARED_ASSETS';
export const FETCH_PROVIDER_BY_TYPE = 'estatePlan/FETCH_PROVIDER_BY_TYPE';
export const HANDLE_ASSETS_SEARCHING = 'estatePlan/HANDLE_ASSETS_SEARCHING';
